import React from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import Page from 'components/page/page.component';

import {
    archivePropertyAdminRoutine,
    closeBiddingRoutine,
    openBiddingRoutine,
    undoArchivePropertyRoutine
} from 'state/properties/properties.routines';

import PropertyList from 'components/property-list/property-list.component';

const Properties = ({ history }) => {
    const dispatch = useDispatch();

    const handleViewPropertyClick = ({ id }) => {
        if (history) history.push(`/admin/properties/${id}`);
    };

    const handleArchivePropertyClick = ({ id }) => {
        if (dispatch) dispatch(archivePropertyAdminRoutine(id));
    };
    const handleUndoArchivePropertyClick = ({ id }) => {
        if (dispatch) dispatch(undoArchivePropertyRoutine(id));
    };

    const handleClosebidding = ({ id }) => {
        if (dispatch) dispatch(closeBiddingRoutine(id));
    };
    const handleOpenBidding = ({ id }) => {
        if (dispatch) dispatch(openBiddingRoutine(id));
    };

    return (
        <Page noHero pageContentStyle={{ minHeight: '800px', width: '100%', padding: 0 }}>
            <Container fluid className="mb-5 mt-2">
                <Row>
                    <Col>
                        <h1 className="h2">Properties</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <PropertyList
                            onArchiveProperty={handleArchivePropertyClick}
                            onCloseBidding={handleClosebidding}
                            onOpenBidding={handleOpenBidding}
                            onUndoArchiveProperty={handleUndoArchivePropertyClick}
                            onViewProperty={handleViewPropertyClick}
                        />
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export default withRouter(Properties);
